"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardServiceClient = void 0;
const ClientAccountsServiceClient_1 = require("./ClientAccountsServiceClient");
const PortfoliosServiceClient_1 = require("./PortfoliosServiceClient");
const enums_1 = require("../enums");
class DashboardServiceClient {
    constructor(baseUrl, authService, logger = null, apiConfig) {
        this.clientAccountsClient = new ClientAccountsServiceClient_1.ClientAccountsServiceClient(baseUrl, authService, logger, apiConfig);
        this.portfoliosClient = new PortfoliosServiceClient_1.PortfoliosServiceClient(baseUrl, authService, logger, apiConfig);
        this.logger = logger;
    }
    getDashboardDetailsAsync() {
        var _a, _b, _c, _d, _e, _f, _g;
        return __awaiter(this, void 0, void 0, function* () {
            const multiPortfolioInfos = yield this.portfoliosClient.getMultiPortfoliosInfoAsync();
            let clientAccounts = [];
            try {
                const clientAccountSummaries = yield this.clientAccountsClient.getAllClientAccountsAsync(null, null);
                const clientAccountPromises = clientAccountSummaries.map((account) => this.clientAccountsClient.getClientAccountAsync(account.clientAccountKey, false, false));
                clientAccounts = yield Promise.all(clientAccountPromises);
            }
            catch (e) {
                (_a = this.logger) === null || _a === void 0 ? void 0 : _a.log({
                    message: 'Failed to load client accounts',
                    level: enums_1.Severity.Error,
                    error: undefined,
                });
            }
            const practiceKeys = new Set();
            const afslKeys = new Set();
            let practiceLogo;
            let afslLogo;
            let adviserSummary;
            for (const clientAccount of clientAccounts) {
                const adviser = clientAccount.adviser;
                if (!adviser)
                    continue;
                adviserSummary !== null && adviserSummary !== void 0 ? adviserSummary : (adviserSummary = adviser);
                if ((_b = adviser.practice) === null || _b === void 0 ? void 0 : _b.practiceKey) {
                    practiceKeys.add((_c = adviser.practice) === null || _c === void 0 ? void 0 : _c.practiceKey);
                    if (!practiceLogo && adviser.practice.logoUrl) {
                        practiceLogo = adviser.practice.logoUrl;
                    }
                }
                if ((_d = adviser.afsl) === null || _d === void 0 ? void 0 : _d.afslKey) {
                    afslKeys.add((_e = adviser.afsl) === null || _e === void 0 ? void 0 : _e.afslKey);
                    if (!afslLogo && ((_f = adviser.afsl) === null || _f === void 0 ? void 0 : _f.logoUrl)) {
                        afslLogo = (_g = adviser.afsl) === null || _g === void 0 ? void 0 : _g.logoUrl;
                    }
                }
            }
            const logoUrl = practiceKeys.size === 1
                ? practiceLogo || afslLogo
                : afslKeys.size === 1
                    ? afslLogo
                    : undefined;
            return {
                adviser: adviserSummary,
                portfolios: multiPortfolioInfos,
                clients: clientAccounts || [],
                logoUrl,
            };
        });
    }
}
exports.DashboardServiceClient = DashboardServiceClient;
